import React, { useCallback, useState } from 'react';
import { usePopper } from 'react-popper';
import { ActionItem, Float, Prompt } from '../../../ui';
import { ColorPreview } from '../../../ui/ColorPreview';
import { PopperMount } from '../../canvas/ui/PopperElements';
import { InlineWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';

export const DisabledColorWidget = ({ widget }: { widget: InlineWidget }) => {

    const [refElmt, setRefElmt] = useState(null);
    const [popElmt, setPopElmt] = useState(null);

    const { styles, attributes } = usePopper(refElmt, popElmt, {
        placement: 'top',
    });

    const [open, setOpen] = useState(false);
    const onOpen = useCallback(() => setOpen(!open), [open, setOpen]);

    return <>
        <ActionItem ref={setRefElmt} onClick={onOpen}>
            <ColorPreview scale={1.5} color={null} />
        </ActionItem>
        {open && <PopperMount ref={setPopElmt} style={styles.popper} {...attributes.popper}>
            <Prompt ignoreEnter onAction={() => setOpen(false)}>
                <Flexer padding=".5">
                    <Float shadow="lg">
                        <Flexer padding="1">
                            Color is currently being overridden by the associated Zone.
                        </Flexer>
                    </Float>
                </Flexer>
            </Prompt>
        </PopperMount>}
    </>;
};
